function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogoHdH210105(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2000px",
    height: "1000px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#0621a3",
    d: "M 101.5,206.5 C 139.168,206.333 176.835,206.5 214.5,207C 217.196,207.69 219.363,209.19 221,211.5C 222.327,278.085 222.993,344.751 223,411.5C 257.793,356.745 292.959,302.245 328.5,248C 329.833,247.333 331.167,246.667 332.5,246C 372.5,245.333 412.5,245.333 452.5,246C 460.282,251.187 461.449,257.687 456,265.5C 408.833,339.167 361.667,412.833 314.5,486.5C 367.667,562.167 420.833,637.833 474,713.5C 476.546,720.195 474.879,725.528 469,729.5C 454.885,749.282 440.385,768.782 425.5,788C 405.92,789.155 386.254,789.655 366.5,789.5C 346.746,789.655 327.08,789.155 307.5,788C 279.946,750.78 252.78,713.28 226,675.5C 225.959,693.232 225.293,710.899 224,728.5C 222,730.5 220,732.5 218,734.5C 204.441,753.781 190.275,772.614 175.5,791C 135.893,792.649 96.2263,792.982 56.5,792C 53.804,791.31 51.6374,789.81 50,787.5C 48.3361,615.913 48.0028,444.247 49,272.5C 50.7272,269.107 53.3938,266.774 57,265.5C 69.6667,247.5 82.3333,229.5 95,211.5C 96.8049,209.174 98.9716,207.508 101.5,206.5 Z M 92.5,233.5 C 93.6583,243.325 93.8249,253.325 93,263.5C 92.5,264 92,264.5 91.5,265C 84.4763,265.831 77.4763,265.664 70.5,264.5C 77.8584,254.149 85.1917,243.815 92.5,233.5 Z M 399.5,731.5 C 408.045,728.983 409.212,730.65 403,736.5C 401.97,734.654 400.804,732.987 399.5,731.5 Z M 420.5,730.5 C 431.853,730.168 443.186,730.501 454.5,731.5C 445.398,744.051 436.065,756.385 426.5,768.5C 420.602,761.43 415.268,753.93 410.5,746C 413.673,740.674 417.007,735.507 420.5,730.5 Z M 180.5,733.5 C 188.84,733.334 197.173,733.5 205.5,734C 196.967,744.9 188.8,756.067 181,767.5C 180.5,756.172 180.333,744.838 180.5,733.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#0a21a3",
    d: "M 1072.5,206.5 C 1110.5,206.333 1148.5,206.5 1186.5,207C 1189.2,207.69 1191.36,209.19 1193,211.5C 1194.33,277.751 1194.99,344.085 1195,410.5C 1230.13,355.744 1265.63,301.244 1301.5,247C 1342.42,245.345 1383.42,245.012 1424.5,246C 1431.32,250.461 1432.82,256.294 1429,263.5C 1381.3,337.699 1333.8,412.033 1286.5,486.5C 1339.47,562.638 1392.64,638.638 1446,714.5C 1448.27,721.388 1446.27,726.722 1440,730.5C 1426.2,749.934 1412.03,769.1 1397.5,788C 1377.92,789.155 1358.25,789.655 1338.5,789.5C 1318.75,789.655 1299.08,789.155 1279.5,788C 1251.61,750.447 1224.11,712.613 1197,674.5C 1197.54,691.48 1197.54,708.48 1197,725.5C 1180.53,747.309 1164.03,769.143 1147.5,791C 1107.56,792.649 1067.56,792.982 1027.5,792C 1025.38,790.878 1023.54,789.378 1022,787.5C 1020.34,615.913 1020,444.247 1021,272.5C 1024.1,268.947 1027.43,265.614 1031,262.5C 1043.59,244.974 1055.92,227.307 1068,209.5C 1069.65,208.601 1071.15,207.601 1072.5,206.5 Z M 1064.5,233.5 C 1065.66,243.325 1065.82,253.325 1065,263.5C 1064.5,264 1064,264.5 1063.5,265C 1056.17,265.667 1048.83,265.667 1041.5,265C 1049.38,254.622 1057.05,244.122 1064.5,233.5 Z M 1371.5,731.5 C 1380.04,728.983 1381.21,730.65 1375,736.5C 1373.97,734.654 1372.8,732.987 1371.5,731.5 Z M 1392.5,730.5 C 1403.84,730.333 1415.17,730.5 1426.5,731C 1417,743.833 1407.5,756.667 1398,769.5C 1392.87,761.404 1387.37,753.571 1381.5,746C 1385.39,740.954 1389.05,735.787 1392.5,730.5 Z M 1152.5,733.5 C 1160.84,733.334 1169.17,733.5 1177.5,734C 1169.33,744.833 1161.17,755.667 1153,766.5C 1152.5,755.505 1152.33,744.505 1152.5,733.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febbd8",
    d: "M 106.5,219.5 C 140.833,219.5 175.167,219.5 209.5,219.5C 209.333,287.167 209.5,354.834 210,422.5C 213.145,429.128 218.312,431.295 225.5,429C 227.333,427.833 228.833,426.333 230,424.5C 265.5,369.5 301,314.5 336.5,259.5C 372.495,258.333 408.495,258.167 444.5,259C 397,333.167 349.5,407.333 302,481.5C 300.713,487.018 301.713,492.018 305,496.5C 356.71,570.088 408.544,643.588 460.5,717C 426.833,717.667 393.167,717.667 359.5,717C 316.234,655.802 272.234,595.136 227.5,535C 220.915,531.958 215.748,533.458 212,539.5C 211.77,599.833 211.937,660.167 212.5,720.5C 177.167,720.5 141.833,720.5 106.5,720.5C 106.5,553.5 106.5,386.5 106.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febbd8",
    d: "M 1078.5,219.5 C 1112.83,219.5 1147.17,219.5 1181.5,219.5C 1181.33,286.834 1181.5,354.167 1182,421.5C 1183.16,427.16 1186.66,430.16 1192.5,430.5C 1196.39,429.64 1199.55,427.64 1202,424.5C 1237.62,369.418 1273.12,314.252 1308.5,259C 1344.5,258.333 1380.5,258.333 1416.5,259C 1369.21,332.415 1322.04,405.915 1275,479.5C 1271.67,484.167 1271.67,488.833 1275,493.5C 1327.36,567.695 1379.53,642.028 1431.5,716.5C 1398.17,717.667 1364.84,717.833 1331.5,717C 1287.74,656.156 1243.74,595.49 1199.5,535C 1192.27,531.753 1186.77,533.586 1183,540.5C 1183.42,600.496 1183.92,660.496 1184.5,720.5C 1149.17,720.5 1113.83,720.5 1078.5,720.5C 1078.5,553.5 1078.5,386.5 1078.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#0621a3",
    d: "M 746.5,225.5 C 821.013,226.673 880.846,256.673 926,315.5C 975.77,386.342 991.77,464.342 974,549.5C 960.151,610.751 928.985,660.918 880.5,700C 854.624,733.884 822.291,759.55 783.5,777C 691.604,808.734 612.438,789.234 546,718.5C 493.217,655.089 471.217,582.089 480,499.5C 488.078,429.837 517.912,371.67 569.5,325C 573.5,322 577.5,319 581.5,316C 622.603,260.779 677.603,230.612 746.5,225.5 Z M 701.5,385.5 C 749.646,387.149 786.146,408.482 811,449.5C 840.799,504.417 840.966,559.417 811.5,614.5C 787.742,629.017 762.075,633.85 734.5,629C 699.048,621.21 671.548,602.043 652,571.5C 624.9,525.796 619.9,477.796 637,427.5C 639.785,419.929 643.119,412.595 647,405.5C 648.5,402.667 650.667,400.5 653.5,399C 668.759,391.356 684.759,386.856 701.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#0621a3",
    d: "M 1716.5,225.5 C 1787.99,226.333 1846.16,254.333 1891,309.5C 1941.72,377.402 1960.06,453.402 1946,537.5C 1933.64,605.263 1900.64,660.263 1847,702.5C 1791.47,774.827 1718.64,802.993 1628.5,787C 1582.98,775.329 1544.81,751.829 1514,716.5C 1461.97,652.405 1440.63,579.072 1450,496.5C 1458.09,430.824 1485.92,375.324 1533.5,330C 1537.88,325.952 1542.55,322.285 1547.5,319C 1573.05,285.232 1605.05,259.566 1643.5,242C 1667.03,232.331 1691.36,226.831 1716.5,225.5 Z M 1671.5,385.5 C 1721.32,387.65 1758.49,410.317 1783,453.5C 1810.33,506.161 1810.33,558.828 1783,611.5C 1781.95,613.09 1780.79,614.59 1779.5,616C 1730.11,640.277 1684.78,634.277 1643.5,598C 1605.45,558.339 1590.62,511.173 1599,456.5C 1602.29,436.639 1609.12,418.139 1619.5,401C 1635.85,392.084 1653.19,386.918 1671.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febbd8",
    d: "M 741.5,238.5 C 816.794,238.229 876.294,268.562 920,329.5C 966.807,400.34 979.473,477.007 958,559.5C 940.47,622.816 903.97,671.65 848.5,706C 767.31,746.75 691.977,738.083 622.5,680C 573.432,633.023 545.932,575.523 540,507.5C 534.395,432.172 555.729,365.838 604,308.5C 640.848,267.493 686.681,244.159 741.5,238.5 Z M 701.5,385.5 C 684.759,386.856 668.759,391.356 653.5,399C 650.667,400.5 648.5,402.667 647,405.5C 643.119,412.595 639.785,419.929 637,427.5C 619.9,477.796 624.9,525.796 652,571.5C 671.548,602.043 699.048,621.21 734.5,629C 762.075,633.85 787.742,629.017 811.5,614.5C 840.966,559.417 840.799,504.417 811,449.5C 786.146,408.482 749.646,387.149 701.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febbd8",
    d: "M 1711.5,238.5 C 1775.97,237.66 1829.8,260.993 1873,308.5C 1927.95,374.969 1947.95,450.969 1933,536.5C 1920.48,601.936 1887.98,654.769 1835.5,695C 1767.87,739.871 1698.21,743.204 1626.5,705C 1565.58,665.744 1528.08,610.244 1514,538.5C 1499.78,462.727 1514.11,393.06 1557,329.5C 1594.92,276.121 1646.42,245.788 1711.5,238.5 Z M 1671.5,385.5 C 1653.19,386.918 1635.85,392.084 1619.5,401C 1609.12,418.139 1602.29,436.639 1599,456.5C 1590.62,511.173 1605.45,558.339 1643.5,598C 1684.78,634.277 1730.11,640.277 1779.5,616C 1780.79,614.59 1781.95,613.09 1783,611.5C 1810.33,558.828 1810.33,506.161 1783,453.5C 1758.49,410.317 1721.32,387.65 1671.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03d4d4",
    d: "M 61.5,278.5 C 68.5079,278.334 75.5079,278.5 82.5,279C 75.3013,287.899 68.468,297.066 62,306.5C 61.5002,297.173 61.3335,287.839 61.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024db0",
    d: "M 92.5,280.5 C 92.56,279.957 92.8933,279.624 93.5,279.5C 94.8261,294.328 94.8261,308.995 93.5,323.5C 93.8293,308.99 93.4959,294.657 92.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0179bb",
    d: "M 1033.5,278.5 C 1033.17,287.682 1033.51,296.682 1034.5,305.5C 1034.22,306.289 1033.72,306.956 1033,307.5C 1032.18,297.658 1032.34,287.991 1033.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03d4d4",
    d: "M 1033.5,278.5 C 1040.2,278.17 1046.87,278.503 1053.5,279.5C 1047.14,288.185 1040.81,296.852 1034.5,305.5C 1033.51,296.682 1033.17,287.682 1033.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05d5d4",
    d: "M 1064.5,279.5 C 1065.66,294.328 1065.83,309.328 1065,324.5C 1054.58,339.012 1043.91,353.345 1033,367.5C 1032.33,352.833 1032.33,338.167 1033,323.5C 1043.74,308.936 1054.24,294.27 1064.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 92.5,280.5 C 93.4959,294.657 93.8293,308.99 93.5,323.5C 83.4117,338.01 73.0784,352.343 62.5,366.5C 61.5041,352.343 61.1707,338.01 61.5,323.5C 71.5883,308.99 81.9216,294.657 92.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024caf",
    d: "M 61.5,323.5 C 61.1707,338.01 61.5041,352.343 62.5,366.5C 62.44,367.043 62.1067,367.376 61.5,367.5C 60.1739,352.672 60.1739,338.005 61.5,323.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#0721a3",
    d: "M 745.5,324.5 C 809.188,325.756 854.021,355.422 880,413.5C 904.569,475.826 897.902,534.493 860,589.5C 823.433,635.023 776.6,651.523 719.5,639C 678.854,625.423 649.354,599.256 631,560.5C 613.311,520.796 609.644,479.796 620,437.5C 630.61,398.582 652.443,367.749 685.5,345C 704.078,333.642 724.078,326.808 745.5,324.5 Z M 701.5,385.5 C 684.759,386.856 668.759,391.356 653.5,399C 650.667,400.5 648.5,402.667 647,405.5C 643.119,412.595 639.785,419.929 637,427.5C 619.9,477.796 624.9,525.796 652,571.5C 671.548,602.043 699.048,621.21 734.5,629C 762.075,633.85 787.742,629.017 811.5,614.5C 840.966,559.417 840.799,504.417 811,449.5C 786.146,408.482 749.646,387.149 701.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#0721a3",
    d: "M 1715.5,324.5 C 1770.22,324.604 1811.72,347.937 1840,394.5C 1868.85,447 1871.85,501 1849,556.5C 1827.38,604.791 1790.54,633.624 1738.5,643C 1687.3,646.482 1646.47,627.649 1616,586.5C 1583.61,537.985 1575.61,485.652 1592,429.5C 1603.97,392.678 1626.14,363.844 1658.5,343C 1676.24,332.475 1695.24,326.308 1715.5,324.5 Z M 1671.5,385.5 C 1653.19,386.918 1635.85,392.084 1619.5,401C 1609.12,418.139 1602.29,436.639 1599,456.5C 1590.62,511.173 1605.45,558.339 1643.5,598C 1684.78,634.277 1730.11,640.277 1779.5,616C 1780.79,614.59 1781.95,613.09 1783,611.5C 1810.33,558.828 1810.33,506.161 1783,453.5C 1758.49,410.317 1721.32,387.65 1671.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d7d5",
    d: "M 757.5,337.5 C 763.21,337.471 768.877,337.971 774.5,339C 780.492,340.61 786.492,342.11 792.5,343.5C 792.649,344.552 792.483,345.552 792,346.5C 782,359.833 772,373.167 762,386.5C 751.713,381.217 740.88,377.384 729.5,375C 738.964,362.56 748.297,350.06 757.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1726.5,337.5 C 1738.9,337.781 1750.9,340.114 1762.5,344.5C 1753.53,357.306 1744.36,369.973 1735,382.5C 1733.88,384.124 1732.38,385.124 1730.5,385.5C 1720.48,381.106 1710.15,377.606 1699.5,375C 1708.72,362.621 1717.72,350.121 1726.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#04d5d4",
    d: "M 739.5,337.5 C 741.527,337.338 743.527,337.505 745.5,338C 736.833,349.667 728.167,361.333 719.5,373C 708.644,373.223 697.811,373.723 687,374.5C 686.167,374.167 685.333,373.833 684.5,373.5C 689.925,365.24 695.925,357.406 702.5,350C 714.302,343.9 726.635,339.733 739.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#04d5d4",
    d: "M 1710.5,337.5 C 1712.2,337.34 1713.87,337.506 1715.5,338C 1706.64,349.358 1697.97,360.858 1689.5,372.5C 1677.5,373.524 1665.5,374.024 1653.5,374C 1659.17,366.333 1664.83,358.667 1670.5,351C 1683.18,344.162 1696.51,339.662 1710.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 62.5,420.5 C 61.5048,408.345 61.1714,396.011 61.5,383.5C 71.9907,369.196 82.4907,354.863 93,340.5C 93.6667,353.167 93.6667,365.833 93,378.5C 83.002,392.658 72.8354,406.658 62.5,420.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05d5d4",
    d: "M 1064.5,340.5 C 1065.66,352.993 1065.83,365.66 1065,378.5C 1054.58,393.012 1043.91,407.345 1033,421.5C 1032.33,408.833 1032.33,396.167 1033,383.5C 1044,369.492 1054.5,355.159 1064.5,340.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 1771.5,348.5 C 1783.48,353.49 1794.15,360.49 1803.5,369.5C 1792.33,384.5 1781.17,399.5 1770,414.5C 1761.18,405.175 1751.35,397.175 1740.5,390.5C 1750.86,376.482 1761.19,362.482 1771.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 801.5,348.5 C 813.749,353.081 824.416,360.081 833.5,369.5C 822.886,384.781 811.886,399.781 800.5,414.5C 791.366,405.36 781.366,397.36 770.5,390.5C 780.858,376.482 791.191,362.482 801.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0ac9d1",
    d: "M 1524.5,357.5 C 1525.04,357.56 1525.38,357.893 1525.5,358.5C 1523,363.5 1520.5,368.5 1518,373.5C 1510.67,382.167 1503.33,390.833 1496,399.5C 1498.75,393.359 1502.08,387.359 1506,381.5C 1512,373.339 1518.17,365.339 1524.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#09cad1",
    d: "M 555.5,356.5 C 556.043,356.56 556.376,356.893 556.5,357.5C 554,362.5 551.5,367.5 549,372.5C 541.667,381.167 534.333,389.833 527,398.5C 529.074,393.362 531.74,388.362 535,383.5C 541.842,374.47 548.676,365.47 555.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#08c7d1",
    d: "M 672.5,371.5 C 673.043,371.56 673.376,371.893 673.5,372.5C 672.139,374.028 670.972,375.695 670,377.5C 668.663,378.765 667.163,379.265 665.5,379C 668.039,376.63 670.372,374.13 672.5,371.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0ebbcd",
    d: "M 1644.5,368.5 C 1645.53,368.897 1645.69,369.563 1645,370.5C 1642.61,373.966 1639.78,376.966 1636.5,379.5C 1635.48,378.998 1635.31,378.332 1636,377.5C 1639.04,374.631 1641.87,371.631 1644.5,368.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 840.5,376.5 C 849.41,385.468 856.743,395.635 862.5,407C 851.371,422.75 839.871,438.25 828,453.5C 822.032,442.386 815.198,431.886 807.5,422C 818.137,406.556 829.137,391.389 840.5,376.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1809.5,376.5 C 1818.78,385.306 1826.45,395.473 1832.5,407C 1821,422.5 1809.5,438 1798,453.5C 1791.7,442.393 1784.53,431.893 1776.5,422C 1787.74,406.937 1798.74,391.77 1809.5,376.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024caf",
    d: "M 61.5,383.5 C 61.1714,396.011 61.5048,408.345 62.5,420.5C 62.44,421.043 62.1067,421.376 61.5,421.5C 60.175,408.673 60.175,396.006 61.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 62.5,475.5 C 61.5046,463.011 61.1713,450.344 61.5,437.5C 71.9907,423.196 82.4907,408.863 93,394.5C 93.6667,407.833 93.6667,421.167 93,434.5C 82.6162,448.044 72.4496,461.711 62.5,475.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 1034.5,475.5 C 1033.5,463.011 1033.17,450.344 1033.5,437.5C 1043.5,422.841 1054,408.508 1065,394.5C 1065.67,407.5 1065.67,420.5 1065,433.5C 1055,447.658 1044.84,461.658 1034.5,475.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05d3d4",
    d: "M 1508.5,398.5 C 1509.04,398.56 1509.38,398.893 1509.5,399.5C 1505.72,410.303 1502.72,421.303 1500.5,432.5C 1488.79,446.716 1477.62,461.383 1467,476.5C 1469.14,461.723 1473.14,447.389 1479,433.5C 1489.42,422.254 1499.25,410.587 1508.5,398.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05d3d4",
    d: "M 538.5,399.5 C 536.551,410.322 534.051,421.322 531,432.5C 519.314,447.193 507.98,462.193 497,477.5C 499.297,461.988 503.631,446.988 510,432.5C 519.651,421.678 529.151,410.678 538.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d7d5",
    d: "M 867.5,418.5 C 873.902,429.214 877.402,440.88 878,453.5C 866.667,468.833 855.333,484.167 844,499.5C 840.934,488.2 837.434,477.034 833.5,466C 844.65,450.02 855.983,434.187 867.5,418.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d7d5",
    d: "M 1836.5,418.5 C 1840.59,423.68 1843.42,429.68 1845,436.5C 1846.82,442.078 1847.82,447.745 1848,453.5C 1836.33,469.167 1824.67,484.833 1813,500.5C 1811.42,489.422 1808.42,478.755 1804,468.5C 1803.33,466.833 1803.33,465.167 1804,463.5C 1815.34,448.795 1826.18,433.795 1836.5,418.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#034db0",
    d: "M 61.5,437.5 C 61.1713,450.344 61.5046,463.011 62.5,475.5C 62.2172,476.289 61.7172,476.956 61,477.5C 60.173,463.994 60.3396,450.66 61.5,437.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#017abb",
    d: "M 1033.5,437.5 C 1033.17,450.344 1033.5,463.011 1034.5,475.5C 1034.22,476.289 1033.72,476.956 1033,477.5C 1032.17,463.994 1032.34,450.66 1033.5,437.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024db0",
    d: "M 93.5,491.5 C 93.829,477.656 93.4957,463.99 92.5,450.5C 92.7828,449.711 93.2828,449.044 94,448.5C 94.8275,463.006 94.6608,477.339 93.5,491.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 92.5,450.5 C 93.4957,463.99 93.829,477.656 93.5,491.5C 83.4117,506.01 73.0784,520.343 62.5,534.5C 61.5043,521.01 61.171,507.344 61.5,493.5C 71.5789,479.019 81.9122,464.686 92.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05d5d4",
    d: "M 1064.5,449.5 C 1065.66,463.661 1065.83,477.994 1065,492.5C 1054.58,507.012 1043.91,521.345 1033,535.5C 1032.33,521.5 1032.33,507.5 1033,493.5C 1043.74,478.936 1054.24,464.27 1064.5,449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d6d5",
    d: "M 1497.5,450.5 C 1498.14,451.097 1498.47,451.93 1498.5,453C 1496.88,467.442 1496.05,481.942 1496,496.5C 1484.33,512.167 1472.67,527.833 1461,543.5C 1460.16,528.431 1460.82,513.431 1463,498.5C 1474.33,482.342 1485.83,466.342 1497.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d7d5",
    d: "M 492.5,542.5 C 491.512,537.36 491.179,532.026 491.5,526.5C 491.118,516.355 491.951,506.355 494,496.5C 505.09,481.321 516.424,466.321 528,451.5C 527.097,466.786 526.43,482.12 526,497.5C 514.824,512.53 503.658,527.53 492.5,542.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03d6d4",
    d: "M 1849.5,468.5 C 1850.83,473.456 1851.49,478.789 1851.5,484.5C 1851.33,489.833 1851.17,495.167 1851,500.5C 1839.72,516.78 1828.05,532.78 1816,548.5C 1815.33,537.167 1815.33,525.833 1816,514.5C 1827.43,499.285 1838.6,483.952 1849.5,468.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03d6d4",
    d: "M 880.5,467.5 C 882.969,478.649 883.136,489.982 881,501.5C 869.333,517.5 857.667,533.5 846,549.5C 846.639,537.839 846.639,526.172 846,514.5C 858.007,499.13 869.507,483.463 880.5,467.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024caf",
    d: "M 61.5,493.5 C 61.171,507.344 61.5043,521.01 62.5,534.5C 62.44,535.043 62.1067,535.376 61.5,535.5C 60.1743,521.339 60.1743,507.339 61.5,493.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 62.5,590.5 C 61.5045,577.677 61.1712,564.677 61.5,551.5C 71.9907,537.196 82.4907,522.863 93,508.5C 93.6667,521.833 93.6667,535.167 93,548.5C 83.002,562.658 72.8354,576.658 62.5,590.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05d5d4",
    d: "M 1064.5,508.5 C 1065.66,521.66 1065.83,534.994 1065,548.5C 1054.58,563.012 1043.91,577.345 1033,591.5C 1032.33,578.167 1032.33,564.833 1033,551.5C 1043.51,537.137 1054.01,522.804 1064.5,508.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d7d5",
    d: "M 527.5,510.5 C 529.993,528.146 532.826,545.812 536,563.5C 524.667,578.833 513.333,594.167 502,609.5C 496.49,592.598 493.49,575.264 493,557.5C 504.718,541.955 516.218,526.289 527.5,510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1496.5,511.5 C 1499.22,528.302 1502.55,545.135 1506.5,562C 1495.4,578.103 1483.9,593.936 1472,609.5C 1465.98,592.722 1462.98,575.388 1463,557.5C 1474.38,542.288 1485.55,526.955 1496.5,511.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0772b9",
    d: "M 491.5,526.5 C 491.179,532.026 491.512,537.36 492.5,542.5C 492.217,543.289 491.717,543.956 491,544.5C 490.181,538.319 490.347,532.319 491.5,526.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#07d1d3",
    d: "M 874.5,530.5 C 867.808,557.179 854.308,580.179 834,599.5C 836.298,591.932 838.631,584.265 841,576.5C 852.421,561.314 863.587,545.981 874.5,530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05d2d4",
    d: "M 1843.5,531.5 C 1837.14,557.518 1823.97,579.851 1804,598.5C 1806.16,590.902 1808.49,583.235 1811,575.5C 1822.46,561.219 1833.29,546.552 1843.5,531.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#06cfd3",
    d: "M 223.5,550.5 C 227.055,554.584 230.389,558.918 233.5,563.5C 230.822,568.188 227.656,572.521 224,576.5C 223.5,567.84 223.334,559.173 223.5,550.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05d3d4",
    d: "M 1195.5,550.5 C 1198.78,554.791 1202.11,559.124 1205.5,563.5C 1202.33,567.833 1199.17,572.167 1196,576.5C 1195.5,567.84 1195.33,559.173 1195.5,550.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024caf",
    d: "M 61.5,551.5 C 61.1712,564.677 61.5045,577.677 62.5,590.5C 62.2172,591.289 61.7172,591.956 61,592.5C 60.1728,578.66 60.3395,564.994 61.5,551.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 62.5,650.5 C 61.5042,636.677 61.1709,622.677 61.5,608.5C 71.7357,593.716 82.2357,579.049 93,564.5C 93.6667,579.167 93.6667,593.833 93,608.5C 83.002,622.658 72.8354,636.658 62.5,650.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05d5d4",
    d: "M 1064.5,564.5 C 1065.66,578.994 1065.83,593.661 1065,608.5C 1054.58,623.012 1043.91,637.345 1033,651.5C 1032.33,636.833 1032.33,622.167 1033,607.5C 1044,593.492 1054.5,579.159 1064.5,564.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 238.5,572.5 C 239.496,572.414 240.329,572.748 241,573.5C 247.711,583.088 254.544,592.588 261.5,602C 248.967,618.233 236.801,634.733 225,651.5C 224.333,631.5 224.333,611.5 225,591.5C 229.51,585.137 234.01,578.804 238.5,572.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1210.5,572.5 C 1218.7,581.554 1226.03,591.387 1232.5,602C 1221.07,618.437 1209.23,634.603 1197,650.5C 1196.47,631.157 1196.14,611.823 1196,592.5C 1200.66,585.675 1205.5,579.009 1210.5,572.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1509.5,574.5 C 1514.96,589.096 1521.29,603.429 1528.5,617.5C 1517.19,633.307 1505.69,648.974 1494,664.5C 1486.47,651.113 1480.31,637.113 1475.5,622.5C 1486.34,606.159 1497.67,590.159 1509.5,574.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 539.5,574.5 C 540.79,575.058 541.623,576.058 542,577.5C 546.338,591.188 551.838,604.354 558.5,617C 547.54,633.08 536.207,648.914 524.5,664.5C 516.522,651.067 510.189,636.9 505.5,622C 516.65,606.02 527.983,590.187 539.5,574.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024cb0",
    d: "M 61.5,608.5 C 61.1709,622.677 61.5042,636.677 62.5,650.5C 62.44,651.043 62.1067,651.376 61.5,651.5C 60.1741,637.006 60.1741,622.672 61.5,608.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 266.5,610.5 C 274.496,620.509 282.163,630.843 289.5,641.5C 277.744,658.011 265.744,674.344 253.5,690.5C 245.479,680.472 237.813,670.139 230.5,659.5C 242.753,643.315 254.753,626.982 266.5,610.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1238.5,610.5 C 1246.5,620.509 1254.16,630.843 1261.5,641.5C 1249.53,657.974 1237.36,674.308 1225,690.5C 1217.31,680.307 1209.81,669.973 1202.5,659.5C 1214.52,643.148 1226.52,626.815 1238.5,610.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 92.5,624.5 C 93.6608,638.661 93.8275,652.994 93,667.5C 82.6667,681.5 72.3333,695.5 62,709.5C 61.3333,695.167 61.3333,680.833 62,666.5C 72.4207,652.648 82.5874,638.648 92.5,624.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 1034.5,708.5 C 1033.5,695.01 1033.17,681.344 1033.5,667.5C 1043.5,652.841 1054,638.508 1065,624.5C 1065.67,638.833 1065.67,653.167 1065,667.5C 1054.62,681.044 1044.45,694.711 1034.5,708.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 562.5,627.5 C 563.496,627.414 564.329,627.748 565,628.5C 573.003,642.169 582.169,655.002 592.5,667C 581.455,682.256 570.289,697.422 559,712.5C 547.834,700.657 538,687.824 529.5,674C 540.888,658.705 551.888,643.205 562.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1532.5,627.5 C 1538.13,634.335 1543.3,641.668 1548,649.5C 1552.51,655.344 1557.01,661.178 1561.5,667C 1551.06,682.599 1540.06,697.766 1528.5,712.5C 1517.26,700.852 1507.59,688.019 1499.5,674C 1510.38,658.4 1521.38,642.9 1532.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 294.5,650.5 C 296.017,650.511 297.184,651.177 298,652.5C 304.833,662.167 311.667,671.833 318.5,681.5C 306.526,697.974 294.359,714.308 282,730.5C 274.097,720.268 266.597,709.768 259.5,699C 271.048,682.733 282.715,666.566 294.5,650.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1266.5,650.5 C 1267.5,650.414 1268.33,650.748 1269,651.5C 1275.92,661.676 1283.09,671.676 1290.5,681.5C 1278.53,697.974 1266.36,714.308 1254,730.5C 1246.1,720.268 1238.6,709.768 1231.5,699C 1242.98,682.686 1254.65,666.519 1266.5,650.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#017abb",
    d: "M 1033.5,667.5 C 1033.17,681.344 1033.5,695.01 1034.5,708.5C 1034.22,709.289 1033.72,709.956 1033,710.5C 1032.17,695.994 1032.34,681.661 1033.5,667.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 598.5,674.5 C 610.411,686.247 623.078,697.08 636.5,707C 625.788,721.589 614.955,736.089 604,750.5C 590.166,741.658 577.332,731.491 565.5,720C 576.718,704.955 587.718,689.788 598.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1568.5,674.5 C 1580.39,685.893 1592.72,696.726 1605.5,707C 1595.01,721.489 1584.51,735.989 1574,750.5C 1559.84,741.844 1547.01,731.511 1535.5,719.5C 1546.75,704.648 1557.75,689.648 1568.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024caf",
    d: "M 92.5,683.5 C 92.56,682.957 92.8933,682.624 93.5,682.5C 94.8255,696.328 94.8255,709.994 93.5,723.5C 93.8289,709.99 93.4956,696.656 92.5,683.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05d5d4",
    d: "M 1064.5,683.5 C 1065.66,696.994 1065.83,710.66 1065,724.5C 1054.58,739.012 1043.91,753.345 1033,767.5C 1032.33,753.833 1032.33,740.167 1033,726.5C 1043.33,712.008 1053.83,697.675 1064.5,683.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 92.5,683.5 C 93.4956,696.656 93.8289,709.99 93.5,723.5C 83.4117,738.01 73.0784,752.343 62.5,766.5C 61.5044,753.344 61.1711,740.01 61.5,726.5C 71.5883,711.99 81.9216,697.657 92.5,683.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 1295.5,690.5 C 1297.19,691.475 1298.69,692.808 1300,694.5C 1306.92,704.676 1314.09,714.676 1321.5,724.5C 1309.53,740.974 1297.36,757.308 1285,773.5C 1276.13,762.267 1267.63,750.767 1259.5,739C 1271.72,722.956 1283.72,706.789 1295.5,690.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 323.5,690.5 C 324.496,690.414 325.329,690.748 326,691.5C 333.639,702.639 341.473,713.639 349.5,724.5C 337.744,741.011 325.744,757.344 313.5,773.5C 304.216,762.712 295.883,751.212 288.5,739C 299.983,722.686 311.65,706.519 323.5,690.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 643.5,712.5 C 657.172,719.667 671.172,726.334 685.5,732.5C 676.667,744.833 667.833,757.167 659,769.5C 657.883,771.124 656.383,772.124 654.5,772.5C 639.678,768.508 625.678,762.674 612.5,755C 623.209,741.07 633.543,726.903 643.5,712.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1613.5,712.5 C 1626.99,720.114 1640.99,726.781 1655.5,732.5C 1646,745.5 1636.5,758.5 1627,771.5C 1626.28,772.059 1625.44,772.392 1624.5,772.5C 1609.68,768.59 1595.68,762.757 1582.5,755C 1592.66,740.675 1603,726.508 1613.5,712.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024caf",
    d: "M 61.5,726.5 C 61.1711,740.01 61.5044,753.344 62.5,766.5C 62.2172,767.289 61.7172,767.956 61,768.5C 60.1727,754.327 60.3393,740.327 61.5,726.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#08cdd2",
    d: "M 836.5,725.5 C 837.239,725.369 837.906,725.536 838.5,726C 830.714,733.388 822.381,740.054 813.5,746C 812.833,746.667 812.167,746.667 811.5,746C 815.12,740.711 819.12,735.711 823.5,731C 828.154,729.666 832.487,727.833 836.5,725.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0acbd2",
    d: "M 1807.5,724.5 C 1808.24,724.369 1808.91,724.536 1809.5,725C 1801.12,732.379 1792.46,739.379 1783.5,746C 1782.67,746.688 1782,746.521 1781.5,745.5C 1785.03,741.141 1788.36,736.641 1791.5,732C 1797.15,729.961 1802.48,727.461 1807.5,724.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d7d5",
    d: "M 357.5,729.5 C 365.84,729.334 374.173,729.5 382.5,730C 387.611,736.095 391.778,742.595 395,749.5C 388.308,758.025 381.808,766.692 375.5,775.5C 358.176,776.666 340.843,776.833 323.5,776C 335.051,760.622 346.385,745.122 357.5,729.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d7d5",
    d: "M 1346.5,776.5 C 1329.33,776.83 1312.33,776.497 1295.5,775.5C 1306.97,760.517 1318.3,745.35 1329.5,730C 1337.83,729.333 1346.17,729.333 1354.5,730C 1358.59,736.177 1362.92,742.177 1367.5,748C 1360.61,757.619 1353.61,767.119 1346.5,776.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00d8d5",
    d: "M 103.5,732.5 C 119.167,733.167 134.833,733.833 150.5,734.5C 139.875,749.571 128.875,764.404 117.5,779C 99.8333,779.667 82.1667,779.667 64.5,779C 76.3333,763.167 88.1667,747.333 100,731.5C 101.011,732.337 102.178,732.67 103.5,732.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02a9c8",
    d: "M 103.5,732.5 C 119.837,732.333 136.17,732.5 152.5,733C 151.956,733.717 151.289,734.217 150.5,734.5C 134.833,733.833 119.167,733.167 103.5,732.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00d8d5",
    d: "M 1075.5,732.5 C 1091.17,733.167 1106.83,733.833 1122.5,734.5C 1111.87,749.571 1100.87,764.404 1089.5,779C 1071.83,779.667 1054.17,779.667 1036.5,779C 1047.67,763.833 1058.83,748.667 1070,733.5C 1071.7,732.594 1073.53,732.261 1075.5,732.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01aac8",
    d: "M 1075.5,732.5 C 1091.51,732.167 1107.51,732.501 1123.5,733.5C 1123.38,734.107 1123.04,734.44 1122.5,734.5C 1106.83,733.833 1091.17,733.167 1075.5,732.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d8d5",
    d: "M 163.5,732.5 C 164.833,732.5 166.167,732.5 167.5,732.5C 167.5,748.167 167.5,763.833 167.5,779.5C 154.829,779.667 142.162,779.5 129.5,779C 141.051,763.622 152.385,748.122 163.5,732.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#01d7d5",
    d: "M 1135.5,732.5 C 1136.83,732.5 1138.17,732.5 1139.5,732.5C 1139.5,748.167 1139.5,763.833 1139.5,779.5C 1126.83,779.667 1114.16,779.5 1101.5,779C 1113.05,763.622 1124.38,748.122 1135.5,732.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d7d5",
    d: "M 694.5,735.5 C 711.557,740.045 728.89,743.045 746.5,744.5C 738.186,756.307 729.52,767.807 720.5,779C 702.695,780.259 685.028,779.259 667.5,776C 667.167,775.667 666.833,775.333 666.5,775C 675.975,761.863 685.309,748.696 694.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d7d5",
    d: "M 1664.5,735.5 C 1681.53,739.95 1698.86,742.783 1716.5,744C 1708.22,755.949 1699.55,767.615 1690.5,779C 1672.63,780.355 1654.97,779.188 1637.5,775.5C 1636.48,774.998 1636.31,774.332 1637,773.5C 1646.39,760.955 1655.55,748.288 1664.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03d6d5",
    d: "M 804.5,736.5 C 805.239,736.369 805.906,736.536 806.5,737C 800.833,744.667 795.167,752.333 789.5,760C 773.114,767.406 756.114,772.906 738.5,776.5C 737.5,776.167 736.5,775.833 735.5,775.5C 743.044,764.911 750.711,754.411 758.5,744C 774.279,743.391 789.613,740.891 804.5,736.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02d7d5",
    d: "M 1770.5,737.5 C 1772.2,737.34 1773.87,737.506 1775.5,738C 1770.22,745.619 1764.55,752.952 1758.5,760C 1741.24,768.637 1723.24,774.137 1704.5,776.5C 1712.31,765.526 1720.31,754.693 1728.5,744C 1736.16,743.278 1743.83,742.612 1751.5,742C 1758.12,741.18 1764.45,739.68 1770.5,737.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03d5d4",
    d: "M 414.5,775.5 C 405.348,776.494 396.015,776.827 386.5,776.5C 391.502,769.991 396.335,763.325 401,756.5C 406.001,762.511 410.501,768.844 414.5,775.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03d5d4",
    d: "M 1386.5,775.5 C 1377.35,776.494 1368.01,776.827 1358.5,776.5C 1363.08,769.686 1367.91,763.019 1373,756.5C 1377.51,762.863 1382.01,769.196 1386.5,775.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#034eb0",
    d: "M 414.5,775.5 C 415.043,775.56 415.376,775.893 415.5,776.5C 405.675,777.823 396.008,777.823 386.5,776.5C 396.015,776.827 405.348,776.494 414.5,775.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024caf",
    d: "M 1295.5,775.5 C 1312.33,776.497 1329.33,776.83 1346.5,776.5C 1329.33,777.827 1312,777.827 1294.5,776.5C 1294.62,775.893 1294.96,775.56 1295.5,775.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#024caf",
    d: "M 1386.5,775.5 C 1387.04,775.56 1387.38,775.893 1387.5,776.5C 1382.5,776.833 1377.5,777.167 1372.5,777.5C 1367.08,777.527 1362.41,777.194 1358.5,776.5C 1368.01,776.827 1377.35,776.494 1386.5,775.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoHdH210105);
export default __webpack_public_path__ + "static/media/MAINLogo-HD_H_21.01.05.dd7607007abbc69fdf8b9a7be0d0083f.svg";
export { ForwardRef as ReactComponent };